import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './components/App';
import { createRoot } from 'react-dom/client';

const paginatedPageMount = document.getElementById('paginated-landing-content-app');

if (paginatedPageMount) {
    const paginatedPageRoot = createRoot(paginatedPageMount);
    paginatedPageRoot.render(<App />);
}